import styles from "./GoogleMap.module.scss";
import { PharmacyDetails } from "./GoogleMap.props";
import { convertCapsToPascal } from "../../utilities";

export const getPharmacyAddress = (pharmacy: PharmacyDetails): Array<string> => {
  const addressLineOne = convertCapsToPascal(pharmacy.address_line_1);
  const addressLineTwo = convertCapsToPascal(String(pharmacy.address_line_2));
  const city = convertCapsToPascal(pharmacy.city);
  const zip = pharmacy.zip.slice(0, 5);

  let pharmacyAddressLineTwo = addressLineTwo;
  if (addressLineTwo.length) {
    pharmacyAddressLineTwo = `${addressLineTwo},`;
  }
  if (city) {
    pharmacyAddressLineTwo = `${pharmacyAddressLineTwo} ${city}`;
  }
  if (pharmacy.state) {
    pharmacyAddressLineTwo = `${pharmacyAddressLineTwo}, ${pharmacy.state}`;
  }
  if (zip) {
    pharmacyAddressLineTwo = `${pharmacyAddressLineTwo}, ${zip}`;
  }

  return [addressLineOne, pharmacyAddressLineTwo];
};

export const getPharmacySubHeading = (pharmacy: PharmacyDetails, distance: string | number): string => {
  const [addressLineOne] = getPharmacyAddress(pharmacy);
  let pharmacyItemSubHeader = `${distance} miles | ${addressLineOne}`;

  if (!distance) {
    pharmacyItemSubHeader = addressLineOne;
  }

  return pharmacyItemSubHeader;
};

interface CustomInfoWindowProps {
  pharmacy: PharmacyDetails;
  distance: string | number;
  id: string;
}

export const CustomInfoWindow = ({ pharmacy, distance, id }: CustomInfoWindowProps): JSX.Element => {
  const [_, addressLineTwo] = getPharmacyAddress(pharmacy);
  return (
    <div className={styles.CustomInfoWindow}>
      <div className={styles.AddressContainer}>
        <div className={styles.PharmacyName}>{pharmacy.name}</div>
        <div>{getPharmacySubHeading(pharmacy, distance)}</div>
        <div>{addressLineTwo}</div>
      </div>
      <div id={id} />
    </div>
  );
};
